import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';

export abstract class AbstractBean {

  public id: any;
  public objectType: EntityTypeEnum;
  public version: number;
  public name: string;
  public selectedLanguage: number;

}
